import apiClient from "../../../../../../services/apiClient";

import { getPeriods } from "../../StatisticaPilgi/actions/statistics";

export const groupsStatisticsActions = {
  getPeriods,

  getInfoAboutGroups: async (params, isArchive) => {
    let paramsArray = Object.entries(params)
      .filter(([key, value]) => value !== 'all' && value !== '')
      .map(([key, value]) => `${key}=${value}`);

    if (isArchive) paramsArray.push('archive=true');

    const linkGet = 'kindergartens/getInfoAboutGroups?' + paramsArray.join('&');
    return await apiClient.get(linkGet);
  },

  updateReservedPlaces: async (kgId) => {
    const url = '/v1/kindergartens/update_reserved_places' + '?kg_id=' + kgId;
    const reqInit = { 
      method: 'POST',
      headers: new Headers({'content-type':'application/json'}),
      mode: 'cors',
      cache: 'default' 
    };

    return fetch(url, reqInit);
  },

  syncRDInfo: async (kgId, period) => {
    const url = 'child_reestr/sync';

    const query = { kg_id: kgId, period: period };
   
    return await apiClient.post(url, query);
  },

  getGroupTabelTemp: async (kgId, groupNumber, period, token) => {
    const linkGet = 'tabel_group_temp/sum/' + kgId;
    const query = {"numberGr": groupNumber, "period": period};

    return await apiClient.post(linkGet, query);
  },

  getChildrenMainInfo: async (kgId, groupId, dateTo, dateFrom, token) => {
    const linkPost = `kindergartens/${kgId}/children/main_info?groups=${groupId}&date_to=${dateTo}&date_from=${dateFrom}`;
    return await apiClient.get(linkPost);
  },

  getInvitesByKg: async (kgId) => {
    const linkGet = 'requests/invites?kg_id=' + kgId;
    return await apiClient.get(linkGet);
  }
};

export const attendanceActions = {
  // Получение основной информации о посещаемости
  getAttendanceInfo: ({kgId, kgGroup, period, isArchive=false}) => {

    const [ mm, yy] = period?.split(".")?.map(v=>+v);

    const per_year = mm > 8 ? yy : yy -1; 

    console.log({ period, per_year})

    const linkGet = `tabel_group/sum/${kgId}${ ( +per_year < 2025 ) ? '?isArchive=true': ''}`;
    const query = { numberGr: kgGroup, period };
    
    return apiClient.post(linkGet, query);
  },

  // Получение временной информации о посещаемости
  getTempAttendanceInfo: ({kgId, kgGroup, period, isArchive=false}) => {
    const linkGet = `tabel_group_temp/sum/${kgId}${isArchive ? '?isArchive=true': ''}`;
    const query = { numberGr: kgGroup, period };
    
    return apiClient.post(linkGet, query);
  },

  // Получение информации о детях в группе
  getChildrenOfGroup: (kgId, idGroup, period) => {
    const dateTo = new Date(period.split('.')[1], period.split('.')[0]-1, 1, 9, 0, 0).toISOString();
    const dateFrom = new Date(new Date(dateTo).getFullYear(), new Date(dateTo).getMonth() + 1, 0).toISOString();
    
    const linkPost = `kindergartens/${kgId}/children/main_info?groups=${idGroup}&date_to=${dateTo}&date_from=${dateFrom}`;
    
    return apiClient.get(linkPost);
  }
  
};